import React, { Component } from "react";
import "./Menu.css";
import pic1 from '../image/pic1.jpeg'
import {HashRouter, Link} from 'react-router-dom';
import insta1 from '../image/insta1.png';
import fb1 from '../image/fb1.png';
import twitter1 from '../image/twitter1.png';
import lin from '../image/lin.png';

class Menu extends Component {
  render() {
    var visibility = "hide";
 
    if (this.props.menuVisibility) {
      visibility = "show";
    }
 
    return (
      <HashRouter>
      <div id="flyoutMenu"
           onMouseDown={this.props.handleMouseDown} 
           className={visibility}>
              <div className="slidecrow">
                <div className="slideccolumn">
                  <img className="img1" src={pic1} width="100" height="150"/>
                </div>
                <div className="slideccolumn">
                 <p>RISHIQUOTE</p>
                </div>
              </div>
      <a class="close"></a>
        <ul>
      <li>
          <Link className="link1" to="/">Home</Link>
          </li>
          <li>
          <Link className="link" to="/About">About Us</Link>
          </li>
		        <li>
            <Link className="link" to="/Blogs">Blogs</Link>
          </li>
        <li>
        <Link className="link" to="/Contact">Contact</Link>
        </li>
        <li>
        <Link className="link" to="/">Buy Posters</Link>
        </li>
        <li>
        <Link className="link" to="/">See The Future</Link>
        </li>
        <li>
        <Link className="link" to="/">Advertise With Us</Link>
        </li>
        <li>
      <div className="siderow">
          <div className="sidecolumn">
            <a href="https://www.instagram.com/rishiquote">
              <img className="sm" src={insta1} />
            </a>
          </div>
          <div className="sidecolumn">
            <a href="https://www.facebook.com/rishiquote">
              <img className="sm" src={fb1} />
            </a>
          </div>
          <div className="sidecolumn">
            <img className="sm" src={twitter1} />
          </div>
          <div className="sidecolumn">
            <img className="sm" src={lin} />
          </div>
        </div>
        </li>   
        <li>
          <li>
          <hr/>
          </li>
          <p className="scr">
         <span>&copy;RishiQuote 2020 | All Rights Resevred.</span>
         <span>RishiQuote is the official trademark &</span>
          <span>Web Page of Instagram/RishiQuote.</span></p>
        </li>
        </ul>
        <ul className="bul">
          <li>Terms & Conditions</li>
          <li>Policy in General</li>
          <li>Get Featured on Blog</li>
          <li>Advertising Policy</li>
        </ul>
      </div>
      </HashRouter>
    );
  }
}
 
export default Menu;